import React from 'react';
import { Icon } from '@iconify/react';

const SocialCard = ({ social }) => {
  return (
    <a href={social.url} target="_blank" rel="noopener noreferrer" className="group relative block">
      <div className={`relative bg-white dark:bg-neutral-800 rounded-2xl p-6 border border-neutral-200 dark:border-neutral-700
        backdrop-blur-sm transform transition-all duration-300 hover:scale-105 hover:shadow-2xl`}
      >
        {/* Decorative background glow on hover */}
        <div className={`absolute inset-0 rounded-2xl bg-gradient-to-br ${social.color}
            opacity-0 group-hover:opacity-10 transition-opacity duration-300 -z-10`}
        />

        {/* Icon */}
        <div className="flex justify-center mb-4">
          <div className={`w-16 h-16 rounded-full bg-gradient-to-br ${social.color} ${social.hoverColor} 
            flex items-center justify-center transform transition-all duration-300 
            group-hover:rotate-12 group-hover:scale-110 shadow-lg group-hover:shadow-xl`}
          >
            <Icon icon={social.icon} className="w-8 h-8 text-white" />
          </div>
        </div>
        
        {/* Text Content */}
        <div className="text-center">
          <h3 className="font-bold text-lg mb-2 text-neutral-800 dark:text-neutral-200 transition-colors duration-300">
            {social.name}
          </h3>
          <p className="text-neutral-700 dark:text-neutral-400 text-sm font-medium break-all 
            opacity-0 group-hover:opacity-100 group-hover:italic transition-opacity duration-300">
            {social.username}
          </p>
        </div>

        {/* Top-right arrow icon */}
        <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <Icon icon="mdi:arrow-top-right" className="w-5 h-5 text-neutral-400 dark:text-neutral-500" />
        </div>
      </div>
    </a>
  );
};

export default SocialCard;
